import { render, staticRenderFns } from "./xeArea.vue?vue&type=template&id=37c3c0e7&scoped=true"
import script from "./xeArea.vue?vue&type=script&lang=js"
export * from "./xeArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c3c0e7",
  null
  
)

export default component.exports